import React from "react";
import { useForm, Controller } from "react-hook-form";
import { useNavigate, Navigate } from "react-router-dom";
import { Editor } from "primereact/editor";

import DashboardLayout from "./components/Layout";
import useRole from "./components/useRole";
import { createEvent, uploadEventPhoto } from "../../api/plan";

const CreateEventPage = () => {
  const navigate = useNavigate();
  const { isAdmin } = useRole();
  const [photoFile, setPhotoFile] = React.useState(null);

  const {
    register,
    handleSubmit,
    control,
    formState: { isSubmitting, errors },
  } = useForm();

  const onSubmit = async (formData) => {
    const payload = {
      title: formData.title,
      description: formData.description,
      place: formData.place,
      date: formData.date + "T" + formData?.time + ":00",
      endDate: formData.endDate + "T" + formData?.endTime + ":00",
      ticketCCEmail: formData.ticketCCEmail,
      supportPhoneNumber: formData.supportPhoneNumber,
      publicKey: formData.publicKey,
      privateKey: formData.privateKey,
      isPremium: formData.isPremium,
    };

    const res = await createEvent(payload);
    const newEventId = res?.data?.data?._id;
    const token = res?.data?.token;
    if (token) {
      localStorage.setItem("auth", token);
    }
    if (newEventId && photoFile) {
      await uploadEventPhoto(newEventId, photoFile);
    }
    if (newEventId) {
      navigate(`/dashboard/${newEventId}`);
    }
  };
  if (!isAdmin) return <Navigate to="/dashboard" replace />;


  return (
    <DashboardLayout id={null}>
      <div className="max-w-2xl mx-auto mt-10 bg-white p-8 rounded-xl shadow">
        <h2 className="text-2xl font-bold mb-6">➕ Yeni Tədbir</h2>

        {/* Photo upload section */}
        <div className="mb-6 p-4 border border-gray-200 rounded-lg">
          <h3 className="text-base font-semibold mb-3">Şəkil</h3>
          {photoFile && (
            <img src={URL.createObjectURL(photoFile)} alt="Önizləmə" className="w-full max-h-48 object-cover rounded mb-3" />
          )}
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setPhotoFile(e.target.files[0] || null)}
            className="text-sm text-gray-600"
          />
        </div>

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700">Ad *</label>
            <input
              {...register("title", { required: true })}
              className="mt-1 w-full border border-gray-300 p-2 rounded"
            />
            {errors.title && <p className="text-red-500 text-xs mt-1">Ad tələb olunur</p>}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Açıqlama *</label>
            <Controller
              name="description"
              control={control}
              defaultValue=""
              rules={{ required: true }}
              render={({ field }) => (
                <Editor
                  value={field.value}
                  onTextChange={(e) => field.onChange(e.htmlValue)}
                  style={{ height: "320px" }}
                />
              )}
            />
            {errors.description && <p className="text-red-500 text-xs mt-1">Açıqlama tələb olunur</p>}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Dəstək üçün Telefon *</label>
            <input
              {...register("supportPhoneNumber", { required: true })}
              className="mt-1 w-full border border-gray-300 p-2 rounded"
            />
            {errors.supportPhoneNumber && <p className="text-red-500 text-xs mt-1">Telefon tələb olunur</p>}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Məkan</label>
            <input
              {...register("place")}
              className="mt-1 w-full border border-gray-300 p-2 rounded"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Tarix</label>
            <div className="flex space-x-2">
              <input
                type="date"
                {...register("date")}
                className="mt-1 flex-[2] border border-gray-300 p-2 rounded"
              />
              <input
                type="time"
                {...register("time")}
                className="mt-1 flex-[1] border border-gray-300 p-2 rounded"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Son Tarix</label>
            <div className="flex space-x-2">
              <input
                type="date"
                {...register("endDate")}
                className="mt-1 flex-[2] border border-gray-300 p-2 rounded"
              />
              <input
                type="time"
                {...register("endTime")}
                className="mt-1 flex-[1] border border-gray-300 p-2 rounded"
              />
            </div>
          </div>

          <h3 className="text-lg font-semibold mt-6">API Parametrləri</h3>

          <div>
            <label className="block text-sm font-medium text-gray-700">Email (bilet kopyası üçün)</label>
            <input
              type="email"
              {...register("ticketCCEmail")}
              className="mt-1 w-full border border-gray-300 p-2 rounded"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Public Key *</label>
            <input
              {...register("publicKey", { required: true })}
              className="mt-1 w-full border border-gray-300 p-2 rounded"
            />
            {errors.publicKey && <p className="text-red-500 text-xs mt-1">Public Key tələb olunur</p>}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Private Key *</label>
            <input
              {...register("privateKey", { required: true })}
              className="mt-1 w-full border border-gray-300 p-2 rounded"
            />
            {errors.privateKey && <p className="text-red-500 text-xs mt-1">Private Key tələb olunur</p>}
          </div>

          <div className="flex items-center">
            <input
              type="checkbox"
              {...register("isPremium")}
              className="mr-2"
            />
            <label className="text-sm text-gray-700">Premium (əsas səhifədə göstər)</label>
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className="bg-black text-white px-4 py-2 rounded hover:bg-gray-800"
          >
            {isSubmitting ? "Yaradılır..." : "Yarat"}
          </button>
        </form>
      </div>
    </DashboardLayout>
  );
};

export default CreateEventPage;
